/** Preset categories shown in the main grid (ids match API). */
export const HANGMAN_PRESET_CATEGORIES = [
  { id: "animals", label: "Animals" },
  { id: "food", label: "Food & Snacks" },
  { id: "movies", label: "Movies & TV" },
  { id: "sports", label: "Sports" },
  { id: "school", label: "School Days" },
  { id: "nature", label: "Nature" },
  { id: "superheroes", label: "Super Heroes" },
  { id: "potty", label: "Potty Humor" },
  { id: "vehicles", label: "Vehicles" }
];

/** @deprecated use HANGMAN_PRESET_CATEGORIES — kept for any older imports */
export const HANGMAN_CATEGORIES = [
  ...HANGMAN_PRESET_CATEGORIES,
  { id: "random", label: "Random" }
];

export function categoryLabel(id, customLabel = "") {
  if (id === "custom" && customLabel) return customLabel;
  const found = HANGMAN_CATEGORIES.find((c) => c.id === id);
  if (found) return found.label;
  if (customLabel) return customLabel;
  return id || "Hangman";
}

export const HANGMAN_DIFFICULTIES = [
  { id: "easy", label: "Easy" },
  { id: "medium", label: "Medium" },
  { id: "hard", label: "Hard" }
];

export const MAX_WRONG_BY_DIFFICULTY = {
  easy: 12,
  medium: 9,
  hard: 9
};

/** @deprecated prefer maxWrongForDifficulty */
export const MAX_WRONG = 9;

export function maxWrongForDifficulty(difficulty) {
  return MAX_WRONG_BY_DIFFICULTY[difficulty] || MAX_WRONG_BY_DIFFICULTY.medium;
}
export const MIN_ROUNDS = 1;
export const MAX_ROUNDS = 10;
export const DEFAULT_ROUNDS = 3;

export const ALPHABET_ROWS = [
  ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"],
  ["K", "L", "M", "N", "O", "P", "Q", "R", "S"],
  ["T", "U", "V", "W", "X", "Y", "Z"]
];

export const GUEST_CHALK_COLORS = [
  "#f5e6a3",
  "#a8d8ea",
  "#f8b4c4",
  "#b8e0b8",
  "#e0c3fc",
  "#ffd8a8"
];
